// This file isn't used on its own, and its consumers are awaited.
// eslint-disable-next-line no-restricted-syntax
import { datalayer } from '@zillow/universal-analytics';
import { ClickstreamEvent } from '../types';
import { logClickstreamEvent } from './logClickstreamEvent';

declare global {
    // eslint-disable-next-line no-var
    var CLICKSTREAM_LOGGER_INITIALIZED: boolean;
}
export const CLICKSTREAM_EVENT_NAME = 'clickstream-event';
export const initializeClickstreamLogger = (SHOULD_LOG: boolean) => {
    if (SHOULD_LOG && !globalThis.CLICKSTREAM_LOGGER_INITIALIZED) {
        datalayer.on(CLICKSTREAM_EVENT_NAME, (e: ClickstreamEvent) => {
            logClickstreamEvent(e);
        });
        globalThis.CLICKSTREAM_LOGGER_INITIALIZED = true;
    }
};
